import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'rankingButton',
    'insuranceFeeButton',
    'shownControlContainer',
    'shownControl',
    'shownCheckedButton',
    'shownAllButton',
    'tbody',
  ]

  static values = {
    inChoiceProcess: { type: Boolean, default: true },
    serialNumberRanking: { type: Array, default: [] },
    serialNumberInsuranceFee: { type: Array, default: [] },
    scrollToReveal: { type: Number, default: 128 },
  }

  connect() {
    this.createSerialNumberValue()
  }

  createSerialNumberValue() {
    const rankingList = []
    const insuranceFeeList = []
    this.tbodyTarget.querySelectorAll('tr').forEach((tr) => {
      rankingList.push(tr.getAttribute(`data-ranking`))
      insuranceFeeList.push(tr.getAttribute(`data-insurance-fee`))
    })

    this.serialNumberRankingValue = rankingList.sort((x, y) => x - y)
    this.serialNumberInsuranceFeeValue = insuranceFeeList
      .filter((value) => value !== '---')
      .sort((x, y) => x - y)
  }

  reorder(event) {
    if (event.currentTarget.classList.contains('active')) return

    const type = event.params.orderType
    const orderList =
      type === 'insurance-fee'
        ? this.serialNumberInsuranceFeeValue
        : this.serialNumberRankingValue

    for (let i = 0; i < orderList.length; i += 1) {
      const row = this.tbodyTarget.querySelector(
        `tr:not(.sorting)[data-${type}='${orderList[i]}']`
      )
      const rows = row.parentNode.querySelectorAll('tr')
      row.classList.add('sorting')
      row.parentNode.insertBefore(row, rows[i])
    }

    this.tbodyTarget
      .querySelectorAll('tr.sorting')
      .forEach((tr) => tr.classList.remove('sorting'))
    this.switchOrderButton()
    this.toggleRowStyle()
  }

  scrollToReveal() {
    if (
      window.scrollY >= this.scrollToRevealValue &&
      this.tbodyTarget.getBoundingClientRect().bottom >
        this.shownControlContainerTarget.offsetHeight
    ) {
      this.shownControlContainerTarget.classList.add('scroll-reveal')
    } else {
      this.shownControlContainerTarget.classList.remove('scroll-reveal')
    }
  }

  switchOrderButton() {
    this.rankingButtonTarget.classList.toggle('active')
    this.insuranceFeeButtonTarget.classList.toggle('active')
  }

  toggleChecked({ params: { itemId } }) {
    this.tbodyTarget
      .querySelector(`[data-id="${itemId}"]`)
      .classList.toggle('checked')

    if (this.hasChoiceableItems() === true) {
      this.shownAllButtonTarget.classList.remove('active')
      this.shownCheckedButtonTarget.classList.add('active')
      this.inChoiceProcessValue = true
    } else {
      this.shownCheckedButtonTarget.classList.remove('active')
      this.shownAllButtonTarget.classList.add('active')
      this.inChoiceProcessValue = false
    }
  }

  toggleShown() {
    if (this.inChoiceProcessValue === true) {
      const unCheckedItems =
        this.tbodyTarget.querySelectorAll('tr:not(.checked)')
      const checkedItems = this.tbodyTarget.querySelectorAll('tr.checked')

      unCheckedItems.forEach((item) => item.classList.add('hidden'))
      checkedItems.forEach((item) => item.classList.remove('hidden'))
      this.toggleRowStyle()
    } else {
      const hiddenItems = this.tbodyTarget.querySelectorAll('tr.hidden')
      hiddenItems.forEach((item) => item.classList.remove('hidden'))
      this.toggleRowStyle()
    }

    if (this.noShownItems()) {
      this.showAllItems()
      this.toggleRowStyle()
    }

    if (this.hasChoiceableItems() === true) {
      this.shownAllButtonTarget.classList.remove('active')
      this.shownCheckedButtonTarget.classList.add('active')
      this.inChoiceProcessValue = true
    } else {
      this.shownCheckedButtonTarget.classList.remove('active')
      this.shownAllButtonTarget.classList.add('active')
      this.inChoiceProcessValue = false
    }
  }

  toggleRowStyle() {
    const shownItems = this.tbodyTarget.querySelectorAll('tr:not(.hidden)')

    shownItems.forEach((item, index) => {
      if ((index + 1) % 2 === 0) {
        item.classList.remove('odd')
        item.classList.add('even')
      } else {
        item.classList.remove('even')
        item.classList.add('odd')
      }
    })
  }

  toggleShownButtons() {
    this.shownCheckedButtonTarget.classList.toggle('active')
    this.shownAllButtonTarget.classList.toggle('active')
  }

  noShownItems() {
    const shownItems = this.tbodyTarget.querySelectorAll('tr:not(.hidden)')
    return shownItems.length <= 0
  }

  showAllItems() {
    const allItems = this.tbodyTarget.querySelectorAll('tr')
    allItems.forEach((item) => item.classList.remove('hidden'))
  }

  hasChoiceableItems() {
    const processedItems = this.tbodyTarget.querySelectorAll(
      'tr:not(.checked):not(.hidden)'
    )
    const unCheckedItems = this.tbodyTarget.querySelectorAll('tr:not(.checked)')

    if (unCheckedItems.length <= 0) return true
    return processedItems.length > 0
  }
}
